// Shopify Smooth Scroll Handler
class ShopifyScroll {
  constructor(options = {}) {
    this.offset = options.offset || 0;
    this.duration = options.duration || 1000;
    this.easing = options.easing || 'easeInOutQuad';
    this.init();
  }

  init() {
    // Handle all anchor clicks
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="#"]');
      if (!link) return;

      const targetId = link.getAttribute('href').split('#')[1];
      if (!targetId) return;

      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      e.preventDefault();
      this.scrollToElement(targetElement);
    });

    // Handle URL hash on page load
    if (window.location.hash) {
      window.addEventListener('load', () => {
        const targetElement = document.getElementById(window.location.hash.slice(1));
        if (targetElement) {
          setTimeout(() => {
            this.scrollToElement(targetElement);
          }, 100);
        }
      });
    }
  }

  getHeaderOffset() {
    let offset = this.offset;
    
    // Account for announcement bar if present
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      offset += announcementBar.offsetHeight;
    }

    // Account for sticky header if present
    const header = document.querySelector('header.header-wrapper, .site-header');
    if (header) {
      offset += header.offsetHeight;
    }

    return offset;
  }

  scrollToElement(element) {
    const startPosition = window.pageYOffset;
    const targetPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const distance = targetPosition - startPosition - this.getHeaderOffset();
    let startTime = null;

    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / this.duration, 1);

      window.scrollTo(0, startPosition + distance * this.ease(progress));

      if (timeElapsed < this.duration) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  }

  ease(t) {
    // easeInOutQuad
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }
}

// Initialize the scroll handler
document.addEventListener('DOMContentLoaded', () => {
  window.shopifyScroll = new ShopifyScroll({
    offset: 0, // Additional offset in pixels
    duration: 800, // Animation duration in milliseconds
  });
});